import { Box, Typography } from "@mui/material";

import type { FC } from "react";

export const EGiftingModalContent: FC = () => (
  <Box>
    <Box sx={(theme) => ({ height: 250, bgcolor: theme.palette.background.paper })}>
      {/* oxlint-disable-next-line react/iframe-missing-sandbox -- First-party video embed from media.changeengine.com */}
      <iframe
        src="https://media.changeengine.com/v/822cb750-6b7f-42c2-b7b8-b2d12e1e202d"
        title="video"
        width="100%"
        height="100%"
        allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
        allowFullScreen
        style={{ border: "none" }}
      />
    </Box>
    <Typography sx={{ mt: 2 }} variant="body2">
      Make Recognition Unforgettable—In Just a Click.
    </Typography>
    <Typography sx={{ mt: 2 }} variant="body2">
      Recognize your team with no effort! From birthdays to big wins, send personalized gifts or
      meaningful donations in seconds.
    </Typography>
    <Typography sx={{ mt: 2 }} variant="body2">
      No shipping. No guesswork. Just instant impact, anywhere in the world.
    </Typography>
    <Typography sx={{ mt: 2 }} variant="body2">
      E-Gifting lets employees choose what matters most—whether it’s a gift card or a cause close to
      their heart. It’s fast, thoughtful, and totally seamless.
    </Typography>
    <Typography sx={{ mt: 2 }} variant="body2">
      Start sending smiles right away!
    </Typography>
  </Box>
);
